<template>
  <div class="content-warpper">
    <div class="warpper-title">
      <i class="iconfont iconiconfont-baoming"></i>
      报名表管理
    </div>
    <div class="padding-sm">
      <div class="flex align-center justify-between margin-bottom-sm">
        <div class="flex align-center condition-warpper">
        </div>
        <router-link to="/projectOffice/signupEdit">
          <el-button type="primary">
            <p class="flex align-center font-size">
              <i class="iconfont iconxinzeng margin-right-xs"></i>新增报名表
            </p>
          </el-button>
        </router-link>
      </div>
      <div class="table-warpper">
        <el-table
            :data="signList"
            header-row-class-name="table-header"
            row-class-name="table-row"
            alig="center"
            fit
            style="width: 100%"
        >
          <el-table-column label="ID">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.id }}
              </div>
            </template>
          </el-table-column>
          <el-table-column label="报名表">
            <template slot-scope="scope">
              <div class="table-item">
                {{ scope.row.title }}
              </div>
            </template>
          </el-table-column>

          <el-table-column label="类型">
            <template slot-scope="scope">
              <div class="table-item">
                <span v-if="scope.row.type ===1">培训报名</span>
                <span v-if="scope.row.type ===2">考试报名</span>
                <span v-if="scope.row.type ===3">考务报名</span>
                <span v-if="scope.row.type ===4">考官报名</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <div class="table-operate">
                <el-button
                    size="medium"
                    type="primary"
                    @click="editItem(scope.row.id)"
                >编辑
                </el-button>
                <el-button
                    size="medium"
                    type="danger"
                    @click="deleteItem(scope.row.id)"
                >删除
                </el-button>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
            v-if="signList.length > 0"
            class="page-all"
            background
            @current-change="setPage"
            :current-page.sync="page"
            :page-size="limit"
            layout="prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import {examEnrollList, delExamEnroll} from "@/api/projectOffice";

export default {
  name: "signup",
  data() {
    return {
      signList: [],
      page: 1,
      total: 0,
      limit: 10,
    };
  },
  created() {
    this.$emit(
        "setIndex",
        this.$route.path,
        "当前位置：报名表管理",
        false
    );
    // if(this.$route.query.page) this.page = Number(this.$route.query.page)
    this.getList();
  },
  methods: {
    async getList() {
      let _list = await examEnrollList(
          this.page,
          this.limit,
          1,
      );
      this.signList = _list.data.list;
      this.total = _list.data.count;
    },
    //  修改路径
    setPath() {
      this.$router.push({
        path: '/projectOffice/signup',
        query: {
          page: this.page,
        }
      })
    },
    setPage() {
      this.getList();
    },
    editItem(id) {
      this.$router.push('/projectOffice/signupEdit?id=' + id)
    },
    deleteItem(id) {
      this.$confirm("确定要删除该报名表吗？", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        cancelButtonClass: "msg-btn",
        confirmButtonClass: "msg-btn",
        center: true
      }).then(() => {
        this.sureDelete(id);
      });
    },
    async sureDelete(id) {
      console.log(id)
      let _state = await delExamEnroll(id,0);
      if (this.signList.length === 1 && this.page > 1) {
        this.page--;
      }
      this.getList();
      this.$message.success(_state.msg);
    }
  },
  watch:{
    page() {
      this.setPath()
    },
    $route() {
      this.getList();
    }
  }
}
</script>

<style scoped lang="scss">

</style>